module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-cacheManger"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('cacheManger_title'),
      "url": "/opera/center",
      "replace": "true"
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "size": "small",
      "title": _vm.$t('cacheManger_clearCloudAddress'),
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearData('clearCloudAddress')
      }
    }
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.$t('cacheManger_clear')))])]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "type": "default",
      "title": _vm.$t('cacheManger_clearCloudParamCache'),
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearData('clearCloudParamCache')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('cacheManger_clear')))])]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "type": "default",
      "title": _vm.$t('cacheManger_clearCloudWithoutUserInfo'),
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearData('clearCloudWithoutUserInfo')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('cacheManger_clear')))])]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "size": "small",
      "title": _vm.$t('cacheManger_clearAddress'),
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearData('clearAddress')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('cacheManger_clear')))])]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "type": "default",
      "title": _vm.$t('cacheManger_clearParamCache'),
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearData('clearParamCache')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('cacheManger_clear')))])]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "type": "default",
      "title": _vm.$t('cacheManger_clearAllWithoutUserInfo'),
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearData('clearAllWithoutUserInfo')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('cacheManger_clearAllWithoutUserInfo')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1e73af90","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/cacheMange.vue
// module id = 1746
// module chunks = 107